export const inventoryClassTypes = {
  BUSINESS_PREMIER: 'A',
  STANDARD: 'B',
  STANDARD_PREMIER: 'H',
  WHEELCHAIR: 'W',
  COMPANION: 'C',
  THWHEELCHAIR: 'TW',
  THCOMPANION: 'TC',
  THBUSINESS_PREMIER: 'TA',
  THSTANDARD: 'TB',
  THSTANDARD_PREMIER: 'TH',
  BLOCKED_SEATS: 'KL',
  EVACUATION_CHAIR: 'E',
  EVACUATION_CHAIR_B: 'EB',
  EVACUATION_CHAIR_H: 'EH',
  EVACUATION_CHAIR_A: 'EA',
  EVACUATION_CHAIR_STANDARD: 'X',
  EVACUATION_CHAIR_PLUS: 'Y',
  EVACUATION_CHAIR_PREMIER: 'Z'
};

export const bookingStatus = {
  CANCELLED: 'CANCELLED',
  CHECKED_IN: 'CHECKED_IN',
  PRR_REFUNDED: 'PRR_REFUNDED',
  CONFIRMED: 'CONFIRMED',
  IN_AFTERSALES: 'IN_AFTERSALES',
  ON_HOLD: 'ON_HOLD',
  PENDING_REFUND: 'PENDING_REFUND',
  PROVISIONAL: 'PROVISIONAL',
  REFUNDED: 'REFUNDED',
  TEMPORARILY_CANCELLED: 'TEMPORARILY_CANCELLED',
  TEMPORARILY_ON_HOLD: 'TEMPORARILY_ON_HOLD',
  OVERPAID: 'OVERPAID',
  PENDING_CHANGES: 'PENDING_CHANGES',
  VOIDED: 'VOIDED',
  PRR_ATTEMPTED: 'PRR_ATTEMPTED',
  SUSPENDED: 'SUSPENDED',
  UNDERPAID: 'UNDERPAID',
  EXPIRED_ON_HOLD: 'EXPIRED_ON_HOLD',
  PLACEHOLDER: 'PLACEHOLDER',
  UKENTRYDENIED: 'UKENTRYDENIED'
};

export const bookingStatusTypes = {
  [bookingStatus.CONFIRMED]: 'confirmed',
  [bookingStatus.PROVISIONAL]: 'provisional',
  [bookingStatus.CANCELLED]: 'cancelled',
  [bookingStatus.TEMPORARILY_CANCELLED]: 'temporallyCancelled',
  [bookingStatus.CHECKED_IN]: 'checkedIn',
  [bookingStatus.PRR_REFUNDED]: 'prrRefunded',
  [bookingStatus.OVERPAID]: 'overpaid',
  [bookingStatus.PRR_ATTEMPTED]: 'prrAttempted',
  [bookingStatus.SUSPENDED]: 'suspended',
  [bookingStatus.PLACEHOLDER]: 'placeholder',
  [bookingStatus.UKENTRYDENIED]: 'UKEntryDenied'
};

export const CUSTOMER_LANGUAGE = 'customer_language';
export const DEFAULT_LANGUAGE = 'EN';
export const NOT_THIRD_PARTY_BOOKING = ['EUROSTAR', 'EIL_DIGITAL', 'E_PACKAGE', 'E_SNAP', 'EIL_BUSINESS', 'EIL_LOYALTY'];

export const BOOKING_TYPES = {
  GENERAL: 'GENERAL',
  ACCESSIBLE_TRAVEL: 'ACCESSIBLE_TRAVEL',
  GROUP: 'GROUP',
  PACKAGE: 'PACKAGE',
  HOTEL_ONLY: 'HOTEL_ONLY',
  EXTRAS_ONLY: 'EXTRAS_ONLY'
};
